export const BUTTON_NAV_LAYOUT = 'flex w-full py-[11px] px-[17px] space-x-[15px] rounded-[10px] hover:bg-[#C41F30]/[0.1] group transition-all duration-300';
export const BUTTON_NAV_TEXT = 'text-xl font-light group-hover:text-[#C41F30]'; 